import React, { FC, SVGProps } from 'react'

export const IconEmptyList: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="52" height="52" rx="26" fill="#F5F5FA" />
    <path
      d="M37.6663 14.3335L24.833 27.1668"
      stroke="#9595A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.6663 14.3335L29.4997 37.6668L24.833 27.1668L14.333 22.5002L37.6663 14.3335Z"
      stroke="#9595A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
